import { getApiUsersMeQueryOptions } from '@shape-construction/api/src-global/hooks/useGetApiUsersMe';
import { toast } from '@shape-construction/arch-ui/src/Toast';
import { showErrorToast } from '@shape-construction/arch-ui/src/Toast/toasts';
import { clearAuthTokens, getToken } from './authorization';
import { jsonDB } from './lib/json-storage';
import { clearLocalDatabase } from './localData/db';
import { ensureMsalIsInitialized, msalInstance, resetMsalRedirect } from './msalAuthConfig';
import queryClient from './queries/query.client.builder';
import { clearAllStores } from './stores/registry';
export const LOGOUT_EVENT = 'shape/logout';
export const hasAuthToken = () => Boolean(getToken());
export const endSession = async () => {
  toast.dismissAll();
  clearAuthTokens();

  // Navigate to auth immediately to prevent components from rendering with missing data
  window.dispatchEvent(new Event(LOGOUT_EVENT));

  // Clear react cache
  await queryClient.cancelQueries().catch(_ => {});
  await queryClient.resetQueries(getApiUsersMeQueryOptions()).catch(_ => {});
  queryClient.clear();

  // Reset redux and zustand state. `clearAllStores` resets zustand's in-memory
  // state synchronously; its promise (the persisted-store teardown) is awaited
  // below alongside the other IndexedDB clears.
  const storesCleared = clearAllStores();

  // Clear MSAL accounts, in-memory cache, and deduped redirect promise
  resetMsalRedirect();
  try {
    await ensureMsalIsInitialized();
    const accounts = msalInstance.getAllAccounts();
    msalInstance.setActiveAccount(null);
    for (const account of accounts) {
      await msalInstance.clearCache({
        account
      });
    }
  } catch (_error) {
    // Ignore errors from clearing MSAL cache
  }
  localStorage.clear();

  // Clear app-owned IndexedDB databases
  await Promise.allSettled([
  // Local data
  jsonDB.clear(), clearLocalDatabase(),
  // Persisted Zustand stores (e.g. issue-builder)
  storesCleared]);
};
export const logout = endSession;
export const endUnauthorizedSession = async () => {
  await endSession().finally(() => {
    showErrorToast({
      message: "You've been inactive for a while and your session expired",
      id: 'session_expired'
    });
  });
};